const storagePath = 'developer-settings__';
const environmentPrefix = 'environment:';
var DeveloperEnvironmentOption;
(function (DeveloperEnvironmentOption) {
    DeveloperEnvironmentOption["DEVELOPMENT"] = "development";
    DeveloperEnvironmentOption["PRODUCTION"] = "production-staging";
})(DeveloperEnvironmentOption || (DeveloperEnvironmentOption = {}));
const cloudEmulationPrefix = 'cloud-emulation:';
var CloudEmulationOption;
(function (CloudEmulationOption) {
    CloudEmulationOption["CLOUD"] = "cloud";
    CloudEmulationOption["LOCAL"] = "local-emulation";
})(CloudEmulationOption || (CloudEmulationOption = {}));
var CloudEmulationType;
(function (CloudEmulationType) {
    CloudEmulationType["FUNCTIONS"] = "functions";
    CloudEmulationType["DB"] = "database & auth";
})(CloudEmulationType || (CloudEmulationType = {}));
const setDeveloperEnvironmentOption = (option) => {
    const path = `${storagePath}__${environmentPrefix}`;
    const ls = window.localStorage;
    return ls.setItem(path, option);
};
const getDeveloperEnvironmentOption = () => {
    const path = `${storagePath}__${environmentPrefix}`;
    const ls = window.localStorage;
    const item = ls.getItem(path);
    switch (item) {
        case DeveloperEnvironmentOption.PRODUCTION:
        case DeveloperEnvironmentOption.DEVELOPMENT:
            return item;
        default:
            return DeveloperEnvironmentOption.DEVELOPMENT;
    }
};
const setCloudEmulationOption = (option, type) => {
    const path = `${storagePath}__${type}-${cloudEmulationPrefix}`;
    const ls = window.localStorage;
    return ls.setItem(path, option);
};
const getCloudEmulationOption = (type) => {
    const path = `${storagePath}__${type}-${cloudEmulationPrefix}`;
    const ls = window.localStorage;
    const item = ls.getItem(path);
    switch (item) {
        case CloudEmulationOption.CLOUD:
        case CloudEmulationOption.LOCAL:
            return item;
        default:
            return CloudEmulationOption.CLOUD;
    }
};
const getAllCloudEmulationOptions = () => {
    const response = {};
    Object.values(CloudEmulationType).forEach((type) => {
        response[type] = getCloudEmulationOption(type);
    });
    return response;
};

export { CloudEmulationOption, CloudEmulationType, DeveloperEnvironmentOption, getAllCloudEmulationOptions, getCloudEmulationOption, getDeveloperEnvironmentOption, setCloudEmulationOption, setDeveloperEnvironmentOption };
